"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @deprecated A promise should be used here instead
 */
class AsyncResponse {
    /**
     * Notify that operation went well
     */
    success() {
        // Intentionally left empty
    }
    /**
     * Notify that operation didn't went well.
     *
     * @param message A message describing the reason for failure
     */
    failure(message) {
        this.success();
    }
}
exports.default = AsyncResponse;
//# sourceMappingURL=AsyncResponse.js.map